import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-43">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold text-brown" data-id="element-46">
            Te pasa así:
          </h2>
          <p className="text-xl text-brown-light" data-id="element-47">
            En la mañana estás "bien"… pero al avanzar el día tu abdomen cambia.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-cream-50 p-8 md:p-10 rounded-2xl border border-cream-200 shadow-sm" data-id="element-48">
          <p className="text-lg text-brown leading-relaxed mb-6" data-id="element-49">
            Te aprieta la ropa. Te sientes pesada. Te da rabia porque no
            entiendes qué hiciste "mal". Y lo peor: empiezas a pensar que es tu
            cuerpo el problema.
          </p>

          <p className="text-2xl font-bold text-terracotta mb-6 text-center" data-id="element-50">
            No lo es.
          </p>

          <p className="text-lg text-brown leading-relaxed" data-id="element-51">
            La mayoría de las veces no es "grasa". Es <strong data-id="element-52">hinchazón</strong>
            . Y la hinchazón se baja con <strong data-id="element-53">señales simples</strong>, no
            con castigo.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 pt-8" data-id="element-54">
          <div className="space-y-4" data-id="element-55">
            <h3 className="text-xl font-bold text-brown" data-id="element-56">La escena real</h3>
            <p className="text-brown-light" data-id="element-57">
              Si tu día es trabajo, pendientes, tráfico, familia, mil pestañas
              abiertas en tu cabeza… tu comida suele ser "lo que se pueda".
            </p>
          </div>
          <div className="space-y-4" data-id="element-58">
            <h3 className="text-xl font-bold text-brown" data-id="element-59">El ciclo diario</h3>
            <ul className="space-y-3 text-brown-light" data-id="element-60">
              <li className="flex items-center gap-3" data-id="element-61">
                <span className="w-2 h-2 bg-terracotta rounded-full" data-id="element-62" />
                Amaneces con el abdomen sensible
              </li>
              <li className="flex items-center gap-3" data-id="element-63">
                <span className="w-2 h-2 bg-terracotta rounded-full" data-id="element-64" />
                Comes algo rápido
              </li>
              <li className="flex items-center gap-3" data-id="element-65">
                <span className="w-2 h-2 bg-terracotta rounded-full" data-id="element-66" />
                Por la tarde te inflas
              </li>
              <li className="flex items-center gap-3" data-id="element-67">
                <span className="w-2 h-2 bg-terracotta rounded-full" data-id="element-68" />
                En la noche estás incómoda
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}